import styled from "styled-components";
import {Link} from "react-router-dom"
import logo from "./Group.svg"
import Moon from "./Moon.svg"
const HeaderDiv = styled.div`
    display: grid;
    justify-content: end;

`

const HeaderListTitle = styled.ul`
    display: flex;
    list-style-type: none;
    margin-top: -40px;
   
`

const HeaderListTitleLi = styled.li`

    width: 130px;
    font-family: 'Segoe UI';
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 27px;
    color: ${props => props.color};
    
    img{
        display: flex;
        margin-top: -6px;
        width: 40px;
        height: 40px;
    }
`

const ListPages = ({click,SubsColors}) => {
    return (
    <HeaderDiv>
        <HeaderListTitle>
                <Link to="/" style={{textDecoration: 'none'}}><HeaderListTitleLi color={SubsColors ? "white" : "black"}>Inicio</HeaderListTitleLi></Link>
                <Link to="/resumo" style={{textDecoration: 'none'}}><HeaderListTitleLi color={SubsColors ? "white" : "black"} >Resumo</HeaderListTitleLi></Link>
                <Link to="/projetos" style={{textDecoration: 'none'}}><HeaderListTitleLi color={SubsColors ? "white" : "black"} >Projetos</HeaderListTitleLi></Link>
                <Link to="/contatos" style={{textDecoration: 'none'}}><HeaderListTitleLi color={SubsColors ? "white" : "black"}>Contatos</HeaderListTitleLi></Link>
                <HeaderListTitleLi ><img src={SubsColors ? logo : Moon} onClick={click} /></HeaderListTitleLi>    
        </HeaderListTitle>
    </HeaderDiv> 
    )
}


export default ListPages